import { Loading } from 'src/components/Loading';
import { StepBuilder } from '../../../StepBuilder';
import { useWizard } from '../../../components/wizard/WizardContext';

export default function CommunicationContent({
  disabled = false,
}: {
  disabled?: boolean;
}) {
  const { isInitializing } = useWizard();

  return (
    <div className="p-4 flex justify-center">
      <div className="w-full max-w-[850px]">
        {isInitializing ? (
          <div className="flex gap-2 items-center justify-center py-12">
            <Loading size="8" />
            <p className="text-neutral-400">Loading...</p>
          </div>
        ) : (
          <>
            <StepBuilder hideTimeWindow={false} disabled={disabled} />
          </>
        )}
      </div>
    </div>
  );
}
